import { FC, useRef } from 'react';
import { RegisterOptions } from 'react-hook-form';

import { useFormFieldScroll } from '~src/commons/utils/hooks/use-form-field-scroll';
import {
  useCountryRegionsLocalizationQuery,
  useRegions,
} from '~src/country-regions/country-regions';
import { SearchableSelect } from '~src/ui/searchable-select';
import { SelectInputV2 } from '~src/ui/select-input-v2';

import { StaticInputProps } from '../config/static-props';

interface RegionInputProps extends Partial<StaticInputProps> {
  validationRules: RegisterOptions;
  label: string;
  fieldType?: string;
}

export const RegionInput: FC<RegionInputProps> = ({ validationRules, fieldType, ...props }) => {
  useCountryRegionsLocalizationQuery();

  const ref = useRef<HTMLSelectElement>(null);
  useFormFieldScroll('region', ref);

  const regions = useRegions();

  const isSearchable = fieldType === 'searchable';

  return isSearchable ? (
    <SearchableSelect
      name="region"
      options={regions}
      validationRules={validationRules}
      {...props}
    />
  ) : (
    <SelectInputV2 name="region" validationRules={validationRules} options={regions} {...props} />
  );
};
